import { Component, OnInit, Input, ViewChild, DoCheck } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartData } from '../../models/operations_persona';

@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss'],
  standalone: false,
})
export class DonutChartComponent implements OnInit, DoCheck {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input() chartData: ChartData = <ChartData>{};

  @Input() title = '';

  margin = 0;
  constructor() {}

  ngOnInit() {
    if (this.chartData) {
      this.margin = this.chartData['height'] / 2;
    }
    //console.log(this.title);//
  }
  ngDoCheck() {
    if (this.chartData && this.chartData.data) {
      if (this.chartData.centerText) {
        this.chartUpdate();
      }
    }
  }
  chartUpdate() {
    const val = this.chartData.centerText;
    const id = this.chartData.id;
    //console.log("id-----"+id);
    const canvas = <HTMLCanvasElement>document.getElementById(id);
    //console.log(canvas);
    if (canvas) {
      const ctx = canvas.getContext('2d');
      const width = this.chartData.width,
        height = this.chartData.height;

      // var fontSize = (height / 114).toFixed(2);
      // ctx.font = fontSize + "em";
      // ctx.textBaseline = "middle";

      const fontSize = 10;
      ctx.font = fontSize + 'px Arial';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = 'black';

      const text = val;
      let textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2;

      const lines = text.split('\n');
      const lineheight = 15;
      for (let i = 0; i < lines.length; i++) {
        if (lines[i] !== undefined) {
          {
            if (lines.length > 1) {
              textX = textX + 5;
              if (width == 180) {
                if (i == 0) {
                  ctx.fillText(lines[i], textX + 15, textY + 10 + i * lineheight);
                  //ctx.fillStyle = 'grey';
                } else {
                  ctx.fillStyle = 'grey';
                  ctx.fillText(lines[i], textX + 5, textY + 5 + i * lineheight);
                }
              } else {
                if (i == 0) {
                  ctx.fillText(lines[i], textX + 15, textY + i * lineheight);
                  //ctx.fillStyle = 'grey';
                } else {
                  ctx.fillStyle = 'grey';
                  ctx.fillText(lines[i], textX + 5, textY + i * lineheight);
                }
              }
            } else {
              ctx.fillText(lines[i], textX, textY + i * lineheight);
            }
          }
        }
      }
      //ctx.fillText(text, textX, textY);
      ctx.save();
    }
  }

  ngOnchanges() {
    this.chart.chart.update();
  }
}
